export default __webpack_public_path__ + "static/media/legguards_of_the_defiant.a38bfc3a.jpg";